import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  Chip
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  chip: {
    margin: '0.2rem',
    color: theme.palette.primary.main,
  }
}))

function Tag(props) {
  const classes = useStyles()
  return <Chip variant="outlined" color="primary" {...props} className={classes.chip} />
}

export default Tag
